import { observer } from 'mobx-react';
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { DateField } from '../../Types';
import EXOInputErrorMessage from '../LegacyDependencies/EXOInputErrorMessage';
import DateInput from './DateInput';
import DateTimeTimeZoneInputStore from './DateTimeInputStore';
import Time from './Time';

interface Props {
  field: DateField;
  disabled: boolean;
}
class DateTimeInput extends React.Component<Props> {
  inputId = `${this.props.field.name}-${uuid()}`;
  dateTimeTimeZoneInputStore = new DateTimeTimeZoneInputStore();

  render() {
    const { field, disabled } = this.props;
    return (
      <>
        <DateInput field={field} disabled={disabled} />
        <Time field={field} disabled={disabled} />
        {field.errors.map((err) => (
          <EXOInputErrorMessage key={err} message={err} />
        ))}
      </>
    );
  }
}

export default observer(DateTimeInput);
